'use client';

import { useQuery } from '@tanstack/react-query';

import { type ActivityAvailabilitySummary, getActivityAvailabilitySummary } from '../services/activities.service';

/**
 * Live availability summary for the public activity-detail page. Fetched on the
 * client on mount (the detail page is SSR-cached for static content; the
 * availability signals are a live island). Drives the header bookable signals
 * and the availability map.
 */
export function useActivityAvailabilitySummary(activityId: string | undefined) {
  return useQuery<ActivityAvailabilitySummary, Error>({
    queryKey: ['activity-availability-summary', activityId],
    queryFn: () => getActivityAvailabilitySummary(activityId as string),
    enabled: !!activityId,
    staleTime: 60 * 1000
  });
}
